// Ian - 2026-05-12
// Linked product swatch hover preview for Envy product cards.
// Uses Envy's swatch preview image layer, but normalises injected image URLs to reduce PLP texture artefacts.
// Recheck after Envy theme updates.

(() => {
  const BOUND_ATTR = 'data-linked-swatches-bound';
  const PREVIEW_IMAGE_WIDTH = 900;

  function normaliseImageUrl(src, width = PREVIEW_IMAGE_WIDTH) {
    if (!src) return '';

    try {
      const url = new URL(src, window.location.origin);
      url.searchParams.set('width', String(width));
      return url.pathname + url.search;
    } catch (error) {
      if (src.includes('width=')) {
        return src.replace(/width=\d+/g, `width=${width}`);
      }

      const separator = src.includes('?') ? '&' : '?';
      return `${src}${separator}width=${width}`;
    }
  }

  function getSwatchPreviewImage(productCard) {
    return productCard.querySelector('img[data-product-card-swatch-image]');
  }

  function getSwatchPreviewWrapper(productCard) {
    return productCard.querySelector('.product-card__image--swatch');
  }

  function setPreviewImage(img, src) {
    if (!img || !src) return;

    const previewSrc = normaliseImageUrl(src);

    img.setAttribute('src', previewSrc);
    img.removeAttribute('srcset');
    img.setAttribute('width', String(PREVIEW_IMAGE_WIDTH));
    img.setAttribute('height', 'auto');
  }

  function showPreview(wrapper) {
    if (!wrapper) return;
    wrapper.style.opacity = '1';
  }

  function hidePreview(wrapper) {
    if (!wrapper) return;
    wrapper.style.opacity = '0';
  }

  function preparePreviewImage(img) {
    if (!img) return;

    const currentSrc = img.currentSrc || img.getAttribute('src');

    if (currentSrc) {
      const previewSrc = normaliseImageUrl(currentSrc);
      img.setAttribute('src', previewSrc);
      img.removeAttribute('srcset');
      img.setAttribute('width', String(PREVIEW_IMAGE_WIDTH));
      img.setAttribute('height', 'auto');
    }
  }

  function bindWrapper(wrapper) {
    if (!wrapper || wrapper.hasAttribute(BOUND_ATTR)) return;

    const productCard = wrapper.closest('product-card');
    if (!productCard) return;

    const previewImage = getSwatchPreviewImage(productCard);
    const previewWrapper = getSwatchPreviewWrapper(productCard);

    if (!previewImage || !previewWrapper) return;

    preparePreviewImage(previewImage);
    hidePreview(previewWrapper);

    const swatches = wrapper.querySelectorAll('[data-linked-swatch]');

    swatches.forEach((swatch) => {
      swatch.addEventListener('mouseenter', () => {
        const hoverPrimaryImage = swatch.dataset.primaryImage;

        if (hoverPrimaryImage) {
          setPreviewImage(previewImage, hoverPrimaryImage);
          showPreview(previewWrapper);
        }
      });

      swatch.addEventListener('mouseleave', () => {
        hidePreview(previewWrapper);
      });
    });

    wrapper.addEventListener('mouseleave', () => {
      hidePreview(previewWrapper);
    });

    wrapper.setAttribute(BOUND_ATTR, 'true');
  }

  function initLinkedSwatchHover() {
    document.querySelectorAll('[data-linked-swatches]').forEach(bindWrapper);
  }

  initLinkedSwatchHover();
  document.addEventListener('DOMContentLoaded', initLinkedSwatchHover);
  document.addEventListener('shopify:section:load', initLinkedSwatchHover);
})();